import { Box, rem } from '@mantine/core';
import { THEME_COLORS } from '@vrplatform/ui-common';

// The VRPlatform logo in white: back stroke, front stroke and dot.
export const VRPilotMark = ({ size = 18 }: { size?: number }) => {
  return (
    <Box
      aria-hidden="true"
      component="svg"
      viewBox="0 0 24 24"
      sx={{
        display: 'block',
        flex: `0 0 ${rem(size)}`,
        height: rem(size),
        width: rem(size),
      }}
    >
      <g transform="translate(1.7 4) scale(0.1)">
        <path
          d="M50.2252 59.8288C40.0967 42.8728 44.8109 21.2027 60.7018 9.47348C78.211 -3.45036 102.892 0.33325 115.725 17.9087L154.724 71.3166C174.938 98.9997 153.952 132.589 127.363 154.221C115.229 164.092 74.0108 99.6477 50.2252 59.8288Z"
          fill={THEME_COLORS.neutral[0]}
          fillOpacity={0.6}
        />
        <path
          d="M8.12247 59.7596C-4.01403 43.3171 -0.523278 20.1492 15.9193 8.01266C32.3618 -4.12383 55.5297 -0.633089 67.6662 15.8095L132.938 104.24C145.075 120.683 141.584 143.851 125.142 155.987C108.699 168.124 85.5312 164.633 73.3947 148.191L8.12247 59.7596Z"
          fill={THEME_COLORS.neutral[0]}
        />
        <circle cx="172.3" cy="34.9" r="32.8" fill={THEME_COLORS.neutral[0]} />
      </g>
    </Box>
  );
};
